import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import * as qs from "query-string";
import { appName } from "../../app.json";

// custom css
import "../QuickAccess/quick.css";

const Scanner = {};

class SearchStaff extends Component {
    keywordRed = React.createRef();
    state = {
        id: "",
        cameras: [],
        activeCam: null,
        message: null,
        redirect: null,
    };
    sc = null;
    onSearch = async () => {
        const { value } = this.keywordRed.current;
        this.beginSearch(value);
    };
    UNSAFE_componentWillMount() {
        // this.props.staffStore.ClearMessage();
        const { redirect } = qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true,
        });
        this.setState({ redirect });
    }
    beginSearch = async (input) => {
        // const staff = await this.props.staffStore.Search(input);
        // if (staff) this.setState({ id: staff.id });
    };
    // start scanner
    // scanner = null;
    onScanStart = async () => {
        const { activeCam } = this.state;

        const scanner = new Scanner.Scanner({
            video: document.getElementById("preview"),
        });
        this.sc = scanner;
        try {
            // add scan listener
            scanner.addListener("scan", async (data) => await this.processContent(data));
            scanner.addListener("inactive", async () => {
                if (this.sc)
                    setTimeout(async () => {
                        this.sc.stop();
                    }, 0);
            });
            await scanner.start(activeCam);
        } catch (err) {
            console.log("Scanner failed to start: ", err);
            await scanner.stop();
        }
    };

    // get all camera on system
    OnCamera = async () => {
        const cameras = await Scanner.Camera.getCameras();
        this.setState({ cameras });
        document.getElementById("scan").click();
    };

    // Select a camera fro scanner
    OnSelectCamera = async (cam) => {
        if (!(this.state.activeCam && this.state.activeCam.id === cam.id)) {
            this.setState({ activeCam: cam });
            setTimeout(async () => {
                await this.onScanStart();
            }, 0);
        }
    };
    /**
     * Stop QRCode scanner
     */
    onStopScanner = () => {
        this.sc.stop();
        document.getElementById("scan").click();
    };

    processContent = async (content) => {
        this.setState({ message: null });
        try {
            const result = JSON.parse(atob(content));
            if (typeof result === "object") {
                // check if object has id and app keys
                if ("id" in result && "app" in result) {
                    if (result.app.trim().toLowerCase() === "igenie") {
                        this.onStopScanner();
                        setTimeout(async () => {
                            await this.beginSearch(result.id);
                        }, 0);
                    }
                }
                this.setState({ message: "Unknown QRCode!" });
            }
        } catch (error) {
            this.setState({ message: "Unknown QRCode!" });
        }
    };
    render() {
        if (this.state.id && this.state.redirect) {
            return (
                <Redirect
                    to={{
                        pathname: this.state.redirect,
                        search: `?ref=${this.state.id}`,
                    }}
                />
            );
        }

        const title = "Search for staff";
        const { path } = this.props.match;

        return (
            <Fragment>
                <Helmet>
                    <title>
                        {title} | {appName}
                    </title>
                </Helmet>

                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-body min-height">
                                <button
                                    type="button"
                                    onClick={this.OnCamera}
                                    style={{ right: "-2px" }}
                                    className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-fault mt-3"
                                >
                                    <i className="material-icons quick-heading">shutter_speed</i>
                                    &nbsp; QRCode Scanner
                                </button>
                                <div className="input-group mb-3 input-group-lg">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">
                                            <i className="material-icons">search</i>
                                        </span>
                                    </div>
                                    <input
                                        type="search"
                                        ref={this.keywordRed}
                                        name="keyword"
                                        className="form-control no-radius"
                                        placeholder="enter staff email or id"
                                        aria-label="staff id or email.."
                                        aria-describedby="basic-addon1"
                                    />
                                    <div className="input-group-append">
                                        <button
                                            type="button"
                                            onClick={this.onSearch}
                                            style={{ right: "-2px", borderRadius: "0 28px 28px 0" }}
                                            className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect btn-success"
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                {/* 
								{staffStore.message && (
									<div className="mt-24">
										<p className="text-danger">{staffStore.message}</p>
									</div>
								)}
								{staffStore.loading && <LoadingSpinner />} */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="qrCodeModel" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-min" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="exampleModalLabel">
                                    QRCode Scanner
                                </h4>
                            </div>
                            {this.state.activeCam && (
                                <div className="modal-body no-padding">
                                    <video id="preview"></video>
                                    <div className="text-center m-t-10">
                                        <p className="text-danger">{this.state.message}</p>
                                    </div>
                                </div>
                            )}

                            {!this.state.activeCam && (
                                <div className="modal-footer">
                                    <h4>Select Camera to continue</h4>
                                </div>
                            )}
                            <div className="modal-footer m-b-20">
                                {this.state.cameras.map((cam) => (
                                    <button
                                        key={cam.id}
                                        type="button"
                                        onClick={() => this.OnSelectCamera(cam)}
                                        className={`mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle ${
                                            this.state.activeCam && this.state.activeCam.id === cam.id && "btn-success"
                                        }`}
                                    >
                                        <i className="material-icons">camera</i>
                                        {cam.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <input type="hidden" data-toggle="modal" data-target="#qrCodeModel" id="scan" />
            </Fragment>
        );
    }
}

export default SearchStaff;
